import { toWorkflowData } from '@data/schemas/workflowData'
import { get } from 'lodash-es'

export const toBasicRegistrationData = (data: unknown): TBasicStepWorkflowData => {
    return {
        inviter: get(data, 'inviter'),
        invitee: get(data, 'prefilledFormValues'),
        isEmailReadOnly: get(data, 'isEmailReadOnly'),
        workflow: toWorkflowData(data),
        workflowType: 'basic',
    }
}
